import { useGeolocation as useGeolocationContext } from 'providers'

// Delegates to GeolocationProvider — returns { data, loading, error }
// to preserve the shape expected by hooks consumers (vs { position, loading, error } from providers)
export const useGeolocation = () => {
  const { position, loading, error, source } = useGeolocationContext()
  return { data: position, loading, error, source }
}
